import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import AppStorage from '@/utils/helpers';

type MobileMenuCart = {
  cart: any[];
  orderData: null;
  cartModalIsOpen: boolean;
  relatedCartItems: any[];
};

const loadMobileMenuCartFromAppStorage = () => {
  if (typeof window !== 'undefined') {
    const cartJSON = AppStorage.get('mobilemenucart');
    return cartJSON ? JSON.parse(cartJSON) : [];
  }
};

const initialState: MobileMenuCart = {
  cart: loadMobileMenuCartFromAppStorage(),
  orderData: null,
  cartModalIsOpen: false,
  relatedCartItems: [],
};

const mobileMenuCartSlice = createSlice({
  name: 'mobileMenuCart',
  initialState,
  reducers: {
    addToCart: (state, { payload }: PayloadAction<any>) => {
      const existingItem = state.cart.find((item) => item.id === payload.id);
      if (existingItem) {
        existingItem.quantity += 1;
        toast.success('Item added to cart!');
      } else {
        state.cart.push({ ...payload, quantity: payload.quantity || 1 });
        toast.success('Item quantity increased in cart!');
      }

      saveCartToAppStorage(state.cart);
    },
    removeFromCart: (state, { payload }: PayloadAction<string>) => {
      state.cart = state.cart.filter((item) => item.id !== payload);
      toast.success('Item removed from cart!');
      console.log('cart', state.cart);
      saveCartToAppStorage(state.cart);
    },
    incrementQuantity: (state, { payload }: PayloadAction<string>) => {
      const item = state.cart.find((item) => item.id === payload);
      if (item) {
        item.quantity += 1;
        toast.success('Item quantity increased in cart!');
      }

      saveCartToAppStorage(state.cart);
    },
    decrementQuantity: (state, { payload }: PayloadAction<string>) => {
      const item = state.cart.find((item) => item.id === payload);
      if (item && item.quantity > 1) {
        item.quantity -= 1;
        toast.success('Item quantity reduced in cart!');
      }

      saveCartToAppStorage(state.cart);
    },
    clearCart: (state) => {
      state.cart = [];
      AppStorage.remove('mobilemenucart');
    },
    addToOrderData: (state, { payload }: PayloadAction<any>) => {
      state.orderData = payload;
    },
    updateCartModalState: (state, { payload }: PayloadAction<boolean>) => {
      state.cartModalIsOpen = payload;
    },
    setRelatedCartItems: (state, { payload }: PayloadAction<any>) => {
      state.relatedCartItems = payload;
    },
  },
});

const saveCartToAppStorage = (cart: any[]) => {
  AppStorage.save('mobilemenucart', JSON.stringify(cart));
};

const { actions, reducer: MobileMenuCartReducer } = mobileMenuCartSlice;

export const {
  addToCart,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  clearCart,
  addToOrderData,
  updateCartModalState,
  setRelatedCartItems,
} = actions;
export default MobileMenuCartReducer;
